import React, { FC, HTMLAttributes } from 'react';
import styles from './Chips.module.scss';
import { ChipsSizes, ChipsType, IconNames } from '@/components/UI/Types';
import Icon from '@/components/UI/icon/Icon';
interface ChipsProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  size?: ChipsSizes;
  isSelected?: boolean;
  type?: ChipsType;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  startIcon?: IconNames;
  endIcon?: IconNames;
  endIconClickHandler?: (e?: React.MouseEvent<HTMLSpanElement>) => void;
}
const Chips: FC<ChipsProps> = ({
  label,
  size = 'medium',
  type = 'primary',
  onClick = () => {},
  disabled = false,
  startIcon = null,
  endIcon = null,
  endIconClickHandler = null,
  isSelected = false,
  className = '',
  id,
  ...props
}) => {
  return <div className={`${className} ${styles['chips-container']} ${styles[size]} ${disabled ? styles['disabled'] : ''} ${isSelected ? styles[type] : ''}`} id={id} onClick={onClick} {...props} data-sentry-component="Chips" data-sentry-source-file="Chips.tsx">
      <div className={styles['label-container']} style={{
      display: 'flex'
    }}>
        {startIcon && <Icon type={'inherit'} size={size} name={startIcon} />}
        <span className={styles['chip-item']}>{label}</span>
        {endIcon && <span className={styles[`end-icon-container`]} onClick={e => {
        e.stopPropagation();
        endIconClickHandler && endIconClickHandler(e);
      }}>
            <Icon type={'inherit'} size={size} name={endIcon} />
          </span>}
      </div>
    </div>;
};
export default Chips;